import Button from 'components/Form/Button';
import Check from 'components/Form/Check';
import BasicTable from 'components/Form/Table';
import TableWrapper from 'components/TableWrapper';
import ContainerAuthenticated from 'containers/Authenticated';
import { CoreContext } from 'context/CoreContext';
import moment from 'moment';
import { useContext, useEffect, useMemo, useState } from 'react';
import { Read } from 'services/financing-desk-controls';
import { Title } from 'ui/styled';
import { exposeStrapiError, formatarValor, marcadorDiferente } from 'utils';
import { formatadores, normalizeName } from 'utils/validators';

export default function ControlDeskFirstInvoice() {
  const { user, filterExpression, setModal } = useContext(CoreContext);
  const [registers, setRegisters] = useState([]);

  const columns = useMemo(() => {
    // Define as colunas padrão
    const defaultColumns = [
      {
        title: 'Id',
        sortable: true,
        ref: 'id',
        renderCell: ({ row }) => {
          // Condição: Se o campo 'curadoria_analise' for 'Analisado'
          const isAnalisado = row?.curadoria_analise === 'Analisado';
          const id = row?.proposta_financeira?.id || row?.proposta;
          if (isAnalisado) {
            return marcadorDiferente(id, '!');
          }
          return id;
        },
      },
      {
        title: 'Data Contato',
        sortable: true,
        ref: 'dataContato',
        align: 'center',
        renderCell: ({ row }) => formatadores.TIMESTAMP_TO_BR(row?.dataContato),
      },
      { title: 'Proposta', ref: 'cod_proposta_externa' },
      ...(user?.administrador ||
      (user?.distribuidores && user.distribuidores.length >= 1)
        ? [
            {
              title: 'Distribuidor',
              sortable: true,
              ref: 'distributor',
            },
          ]
        : []),
      { title: 'Integrador', sortable: true, ref: 'integrator' },
      { title: 'Cliente', sortable: true, ref: 'cliente' },
      { title: 'Cidade', ref: 'cidade' },
      { title: 'UF', ref: 'uf' },
      { title: 'Concessionária', ref: 'concessionaria' },
      { title: 'KWP', ref: 'kwp' },
      {
        title: '1° Fatura',
        ref: '',
        renderCell: ({ row }) => (
          <Check
            checked={row?.primeira_fatura === 'Sim' ? true : false}
            label={''}
            align="center"
          />
        ),
      },
      ...(user?.administrador
        ? [
            {
              title: 'Observações',
              renderCell: ({ row }) => (
                <Button
                  onClick={() => {
                    setModal({
                      type: 'observacao',
                      dados: row,
                      origem: 'Primeira Fatura com Injeção',
                      reload: () => init(),
                    });
                  }}
                  color="botao"
                  nospace
                  mbutton
                  small
                >
                  Adicionar
                </Button>
              ),
            },
          ]
        : []),
    ];
    return defaultColumns.filter((f) => f);
  }, [user, setModal]);

  const rows = useMemo(() => {
    return registers
      ?.filter((item) => !item.primeira_fatura)
      .map((item) => ({
        proposta: item?.proposta_financeira?.id,
        id: item?.id,
        original: item,
        data: item?.proposta_financeira?.createdAt,
        formatedDate: formatadores.TIMESTAMP_TO_BR(
          item?.proposta_financeira?.createdAt
        ),
        cliente: normalizeName(
          item?.proposta_financeira?.informacoes_cliente?.nome_completo
        ),
        distributor: normalizeName(
          item?.proposta_financeira?.distribuidor?.trade_name
        ),
        integrator: normalizeName(
          item?.proposta_financeira?.integrador?.nome_fantasia
        ),
        cidade: normalizeName(
          item?.proposta_financeira?.endereco_instalacao?.cidade
        ),
        uf: item?.proposta_financeira?.endereco_instalacao?.uf,
        status: normalizeName(item?.proposta_financeira?.status),
        //fim do filtro.
        concessionaria: normalizeName(
          item?.proposta_financeira?.informacoes_projeto?.concessionaria
        ),
        kwp: formatarValor(
          item?.proposta_financeira?.informacoes_projeto?.potencia_kWp
        ),
        cod_proposta_externa: normalizeName(
          item?.proposta_financeira?.cod_proposta_externa
        ),
        primeira_fatura: item?.primeira_fatura ? 'Sim' : 'Não',
        address: item?.proposta_financeira?.endereco_instalacao?.rua,
        dataContato:
          item?.data_entrada_primeira_fatura || item?.data_primeira_fatura,
        formatedDateContact: formatadores.TIMESTAMP_TO_BR(
          item?.data_entrada_primeira_fatura || item?.data_primeira_fatura
        ),
        curadoria_analise: item?.curadoria_analise,
        curadoria_analise_bot: item?.curadoria_analise_bot,
        // cnpj_integrador: item?.proposta_financeira?.integrador?.cnpj,
        // cnpj_integrador_clean:
        //   item?.proposta_financeira?.integrador?.cnpj.replace(/\D/g, ''),
        // cpf_cnpj:
        //   item?.proposta_financeira?.informacoes_cliente?.cpf ||
        //   item?.proposta_financeira?.informacoes_cliente?.cnpj,
        // cpf_cnpj_clean: item?.proposta_financeira?.informacoes_cliente?.cpf
        //   ? item?.proposta_financeira?.informacoes_cliente?.cpf.replace(
        //       /\D/g,
        //       ''
        //     )
        //   : item?.proposta_financeira?.informacoes_cliente?.cnpj.replace(
        //       /\D/g,
        //       ''
        //     ),
        cpf_cnpj: item?.cpf_cliente || '-',
        cpf_cnpj_clean:
          item?.cpf_cliente ?? item?.cpf_cliente.replace(/\D/g, ''),
      }));
  }, [registers]);

  const init = async () => {
    // filtra para mostrar os status e caso tenha alguma proposta vazia nao traz resultado.
    const result = await Read(
      '?filters[$or][0][status][$eq]=Entrega e Parecer de acesso' +
        '&filters[$or][1][status][$eq]=Expedição' +
        '&filters[$or][2][status][$eq]=Instalação e Protocolo de conexão' +
        '&filters[$or][3][status][$eq]=Conexão e 1ª Parcela' +
        '&filters[$or][4][status][$eq]=Primeira Fatura' +
        '&filters[proposta_financeira][id][$notIn][0]=null'
    );
    if (result && !exposeStrapiError(result)) {
      const nresult = result.results
        ?.map((m) => {
          return { ...m };
        })
        ?.sort((a, b) => {
          // Pega a data de contato para a proposta 'a'
          const dateA = moment(a.data_entrada_conexao || a.data_enviar_conexao);
          // Pega a data de contato para a proposta 'b'
          const dateB = moment(b.data_entrada_conexao || b.data_enviar_conexao);
          // Retorna a diferença
          // Se dateA for mais antiga, o resultado é negativo e 'a' é colocado antes de 'b'.
          return dateA - dateB;
        });
      setRegisters(nresult);
    }
  };

  useEffect(() => init(), []);

  return (
    <ContainerAuthenticated>
      <Title>Mesa de Controle</Title>
      <TableWrapper title={'1º Fatura com Injeção de Energia'} search>
        <BasicTable
          columns={columns}
          rows={rows?.filter(filterExpression)}
          pagination
        />
      </TableWrapper>
    </ContainerAuthenticated>
  );
}
